import React from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";

const styled = makeStyles({
  root: {
    width: "100%",
    "& .MuiInputLabel-root.Mui-focused": {
      top: "-2px",
      color: "#aaa",
    },
    "& .MuiInputLabel-root": {
      color: "#666666",
      fontWeight: "500",
      fontSize: "12px",
      position: "static",
      transform: "none",
      padding: "10px 10px 0",
      fontFamily: "'Gilroy', sans-serif",
      lineHeight: "14px",
    },
    "& .MuiInput-underline": {
      padding: "0 10px 8px",
      position: "relative",
      fontSize: "12px",
    },
    "& .MuiInput-underline:before": {
      marginTop: "0px",
      borderBottomWidth: "2px",
      borderBottomColor: "#C8C8C8",
    },
    "& .MuiInput-underline:after": {
      marginTop: "0px",
      borderBottomWidth: "2px",
      borderBottomColor: "#38A038",
    },
    "& .MuiInput-input": {
      padding: "0px",
      fontFamily: "'Gilroy', sans-serif",
      color: "#2B2B2B",
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "18px",
      textAlign: (props) => props.textAlign || "left",
      borderBottom: "none",
    },
  },
});
const CustomInput = React.forwardRef(function CustomInput(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      allowNegative={false}
      prefix={other.prefix}
      isAllowed={other.isAllowed}
      decimalScale={other.dotPrecision}
    />
  );
});

CustomInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function Input({
  name,
  label,
  placeholder,
  isAllowed,
  value,
  onChange,
  style,
  dotPrecision,
  prefix,
  fontsize,
  ...props
}) {
  const classes = styled(props);
  return (
    <TextField
      {...props}
      label={label}
      value={value}
      autoComplete="off"
      onChange={onChange}
      name={name}
      className={classes.root}
      placeholder={placeholder}
      InputProps={{
        inputComponent: CustomInput,
        inputProps: {
          isAllowed,
          dotPrecision,
          prefix,
          readOnly: props.readOnly,
        },
        sx: { fontSize: fontsize || 18, p: props.p || 0, m: 0, ...style },
      }}
      variant="standard"
    />
  );
}
